import { formatTime, formatDate } from '../../filter'
import moment from 'moment'

// 约定的数据字段结构
/**
 * 获取编辑数据
 * @returns {
    key: string; // 字段名称
    label: string; // 字段显示名
    value: string; // 字段当前值。枚举值时用英文逗号分隔。已经设值和默认值都可通过当前字段实现。当字段类型为下拉列表等时，要映射到枚举值的展示值
    type: string; // 字段类型
    notNull: string; // 是否必填。0-非必填，1-必填
    enumCode: string; // enumCode":"对应枚举code。当type为下拉列表/选框时用
    length?: number; // 字段长度限制。当type为文本输入框时用
    maxValue?: number; // 最大值。type为数字时用
    minValue?: number; // 最小值。type为数字时用
    canEdit?: boolean; // 自定义的是否可编辑
    selectOption: any[]; // 自定义的下拉选项
    rules?: any[]; // 支持自定义校验规则
    spacialLabelWidth?: number; // 支持自定义label宽度
    symbol?: string; // 输入框后面的单位或符号
    button?: string; // 输入框后面的按钮
    btnFun?: Function; // 输入框后面的按钮
    labelSpan?: Function; // label的栅格比例
    wrapperSpan?: Function; // 内容的栅格比例
	formSpan?: number; // 表单的栅格比例
}
 */

export default function() {
	const res = this.checkParams()
	if (!res) {
		return
	}
	const { order, injured, setting } = this
	let isPAIC = this.isPAIC && this.isFirstVisit && !this.isCarInsurance
	if (!isPAIC) {
		return false
	}

	const hasAnamnesis = !(
		injured.anamnesis && ['0', ''].includes(injured.anamnesis.hasAnamnesis)
	)

	let anamnesisList = []
	if (injured.anamnesis && injured.anamnesis.anamnesisList.length) {
		anamnesisList = injured.anamnesis.anamnesisList
	}

	const modal = [
		{
			label: '诊断名称',
			value: '',
			key: 'clinicalDiagnosis',
			selectOption: [],
			type: 'searchSelect',
			notNull: '1',
			canEdit: true,
			formSpan: 7,
		},
		{
			label: '损伤部位I',
			value: '',
			key: 'injuredPartOne',
			type: 'text',
			notNull: '1',
			canEdit: false,
			formSpan: 8,
		},
		{
			label: '损伤分类',
			value: '',
			key: 'injuredSort',
			selectOption: [],
			type: 'select',
			notNull: '1',
			canEdit: true,
			formSpan: 7,
		},
	]

	const list = anamnesisList.map((item, index) => {
		const valArr = [
			item.clinicalDiagnosis,
			item.injuredPartOne,
			item.injuredSort,
		]

		let arr = modal.map((moadlItem, valIndex) => {
			let obj = {
				...moadlItem,
				value: valArr[valIndex],
			}
			// 组装既往史列表数据
			if (obj.key == 'clinicalDiagnosis') {
				obj.selectOption = [
					{
						key: item.clinicalDiagnosis,
						value: item.clinicalDiagnosis,
						injuredPartTwo: item.injuredPartTwo,
					},
				]
			}
			// 组装损伤分类列表数据
			if (obj.key == 'injuredSort') {
				obj.value = item.diagnosisCode
				obj.selectOption = [
					{
						key: item.diagnosisCode,
						value: item.injuredSort,
					},
				]
			}

			return obj
		})

		return {
			list: arr,
		}
	})

	const obj = {
		title: '既往史信息',
		key: 'anamnesis.anamnesisList', // 提交时对应的字段
		modal: modal, // 每一行的模板
		children: list, // 数据列表
		anamnesis: {
			hasAnamnesis: hasAnamnesis,
		},
	}

	return obj
}
